module.exports = __webpack_public_path__ + "static/media/30.e402d148.png";